export default __webpack_public_path__ + "static/media/hotel-new-york2.c738cf9a.jpg";